import React from 'react';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';
import ValidatedFormField from '../form/ValidatedField';


function CardHolderName (props) {

    return (
        <div className="card-holder-name">
            <ValidatedFormField { ...props }
                type="text"
                id="cardHolderName"
                name="cardholderName"
                field="cardHolderName"
                label={ t('customerdetails.payment.cardholder') }
                placeholder={ t('customerdetails.payment.cardholder') }
                labelClassName="sr-only"
                autoComplete="cc-name"
            />
        </div>
    );

}

CardHolderName.propTypes = _.pick(ValidatedFormField.propTypes, [
    'form',
    'onChange',
    'required',
    'disabled',
    'visited',
    'validation'
]);


export default CardHolderName;



// WEBPACK FOOTER //
// ./src/components/payment/CardHolderName.js